export default "__VITE_ASSET__Cxm_khiu__"